import type { DaysCount } from '@/types/api';
import { nowInCenterTime } from '@/utils/timezone';
import { addDays } from 'date-fns';
import { enrollmentDateToCenterDay } from './enrollmentDateToLocalDay';

export const getMaxCalendarDate = (enrollmentEndDate: string, maxAdvance: DaysCount, timeZone: string): Date => {
  const today = nowInCenterTime(timeZone);
  const enrollmentEnd = enrollmentDateToCenterDay(enrollmentEndDate, timeZone);

  const maxAdvanceDate = addDays(today, maxAdvance);

  if (!enrollmentEnd) return maxAdvanceDate;

  // eslint-disable-next-line unicorn/prefer-math-min-max
  return enrollmentEnd < maxAdvanceDate ? enrollmentEnd : maxAdvanceDate;
};
